{
  "account": {
    "id": "ID",
    "stringId": "ID de cadena",
    "custodianAccountNumber": "Número de custodio",
    "custodianAccountName": "Nombre del custodio",
    "type": "Tipo",
    "translatedAccountType": "Tipo traducido",
    "state": "Estado",
    "lastUpdatedBy": "Última actualización por",
    "applyForGovFunds": "Solicitar fondos gubernamentales",
    "sourceOfFunds": "Origen de los fondos",
    "tlhEnabled": "Recuperación fiscal activada",
    "forceOpen": "Forzar apertura",
    "jurisdiction": "Jurisdicción",
    "feePaymentAccount": "Cuenta de pago de comisiones",
    "taxRank": "Rango fiscal",
    "defaultTaxRank": "Rango fiscal predeterminado",
    "requiresFeeRedirectionSigned": "Requiere redirección de comisiones firmada",
    "feeRedirectionSignedAt": "Redirección de comisiones firmada el",
    "overrideTaxRank": "Rango fiscal de reemplazo",
    "baseCurrency": "Moneda base",
    "availableCurrencies": "Monedas disponibles",
    "translatedNickName": "Apodo traducido",
    "custodianSortingOrderPriority": "Prioridad de orden del custodio",
    "createdAt": "Creado el",
    "updatedAt": "Actualizado el",
    "activatedAt": "Activado el",
    "dealerCode": "Código del dealer",
    "dealerName": "Nombre del dealer",
    "dealerAccountNumber": "Número de cuenta del dealer",
    "groupEmployer": "Empleador del grupo",
    "groupNumber": "Número de grupo",
    "sourceType": "Tipo de origen",
    "externalSourceType": "Tipo de origen externo",
    "eligibleForDisabilityTaxCredit": "Elegible para crédito fiscal por discapacidad",
    "rightOfSurvivorship": "Derecho de supervivencia",
    "respAllBeneficiariesAreInBc": "RESP todos los beneficiarios en BC",
    "user": "Usuario",
    "organization": "Organización",
    "householdClientGroup": "Hogar",
    "repCode": "Código del representante",
    "transactionsTotal": "Total de transacciones",
    "program": "Programa",
    "feeTier": "Nivel de comisión",
    "applicableFeeTier": "Nivel de comisión aplicable",
    "billingSchedule": "Calendario de facturación",
    "applicableBillingSchedule": "Calendario de facturación aplicable",
    "statistics": "Estadísticas",
    "scheduledIncomeFundTransfer": "Transferencia de fondos de ingresos programada",
    "custodianConnection": "Conexión del custodio"
  },
  "subAccount": {
    "id": "ID",
    "name": "Nombre",
    "state": "Estado",
    "suitabilityScore": "Puntuación de idoneidad",
    "calculatedSuitabilityScore": "Puntuación de idoneidad calculada",
    "createdAt": "Creado el",
    "signedAllFormsAt": "Formularios firmados el",
    "completedAt": "Completado el",
    "incompleteFields": "Campos incompletos",
    "approvedAt": "Aprobado el",
    "lastUpdatedBy": "Última actualización por",
    "skipIPS": "Omitir IPS",
    "allowClientDeposits": "Permitir depósitos del cliente",
    "isPartial": "Parcial",
    "liquidated": "Liquidado",
    "tradingProcess": "Proceso de operaciones",
    "baseCurrency": "Moneda base",
    "sourceType": "Tipo de origen",
    "custodianSuitabilityScore": "Puntuación de idoneidad del custodio",
    "financialProductId": "ID producto financiero subcuenta",
    "acceptableFinancialProduct": "Producto financiero aceptable",
    "account": "Cuenta",
    "goal": "Objetivo",
    "organization": "Organización",
    "theme": "Tema",
    "schedule": "Calendario",
    "financialProduct": "Producto financiero",
    "feeTier": "Nivel de comisión",
    "applicableFeeTier": "Nivel de comisión aplicable",
    "billingSchedule": "Calendario de facturación",
    "applicableBillingSchedule": "Calendario de facturación aplicable",
    "suggestedFinancialProduct": "Producto financiero sugerido",
    "statistics": "Estadísticas"
  },
  "goal": {
    "id": "ID",
    "name": "Nombre",
    "type": "Tipo",
    "timeHorizon": "Horizonte temporal",
    "expectedAnnualIncomeCents": "Ingreso anual esperado (centavos)",
    "targetAmountCents": "Monto objetivo (centavos)",
    "retirementAge": "Edad de jubilación",
    "targetDate": "Fecha objetivo",
    "riskQuestion1": "Pregunta de riesgo 1",
    "suitabilityScore": "Puntuación de idoneidad",
    "state": "Estado",
    "calculatedSuitabilityScore": "Puntuación de idoneidad calculada",
    "lastUpdatedBy": "Última actualización por",
    "taxOptimized": "Optimizado fiscalmente",
    "pendingAgreementSignature": "Firma de acuerdo pendiente",
    "tradingProcess": "Proceso de operaciones",
    "timeHorizonLabel": "Etiqueta de horizonte temporal",
    "goalRiskQuestionLabel": "Etiqueta de pregunta de riesgo",
    "createdAt": "Creado el",
    "user": "Usuario",
    "householdClientGroup": "Hogar",
    "organization": "Organización",
    "financialProduct": "Producto financiero",
    "suggestedFinancialProduct": "Producto financiero sugerido",
    "statistics": "Estadísticas"
  },
  "user": {
    "id": "ID",
    "stringId": "ID de cadena",
    "availableCurrencies": "Monedas disponibles",
    "suitabilityScore": "Puntuación de idoneidad",
    "latestNsfs": "Último NSF",
    "state": "Estado",
    "title": "Título",
    "firstName": "Nombre",
    "middleName": "Segundo nombre",
    "lastName": "Apellido",
    "primaryEmail": "Correo principal",
    "dateOfBirth": "Fecha de nacimiento",
    "dateOfDeath": "Fecha de fallecimiento",
    "phone": "Teléfono",
    "gender": "Género",
    "citizenships": "Ciudadanías",
    "foreignTaxExists": "Impuesto extranjero existente",
    "employmentStatus": "Situación laboral",
    "jobTitle": "Cargo",
    "companyType": "Tipo de empresa",
    "studentAreaOfStudy": "Área de estudio",
    "annualIncomeCents": "Ingreso anual (centavos)",
    "annualIncomeStr": "Ingreso anual (cadena)",
    "financialLiquidAssetsCents": "Activos líquidos (centavos)",
    "financialFixedAssetsCents": "Activos fijos (centavos)",
    "totalDebtCents": "Deuda total (centavos)",
    "annualDebtPaymentsCents": "Pagos anuales de deuda (centavos)",
    "debtAssociated": "Deuda asociada",
    "isOfficerOfPublicCompany": "Directivo de empresa pública",
    "isOwnerOfPublicCompany": "Propietario de empresa pública",
    "isMemberOfIiroc": "Miembro de IIROC",
    "politicallyExposedForeignPerson": "Persona políticamente expuesta (extranjero)",
    "politicallyExposedDomesticPerson": "Persona políticamente expuesta (nacional)",
    "closeAssociateOfPEP": "Asociado cercano de PPE",
    "pepReason": "Motivo PPE",
    "investmentKnowledge": "Conocimientos de inversión",
    "investmentKnowledgeLabel": "Etiqueta de conocimientos de inversión",
    "investmentKnowledgeDescription": "Descripción de conocimientos de inversión",
    "isAccreditedInvestor": "Inversor acreditado",
    "riskQuestion1": "Pregunta de riesgo 1",
    "riskQuestion1Label": "Etiqueta pregunta de riesgo 1",
    "riskQuestion2": "Pregunta de riesgo 2",
    "riskQuestion2Label": "Etiqueta pregunta de riesgo 2",
    "retirementAge": "Edad de jubilación",
    "powerOfAttorneyGranted": "Poder notarial concedido",
    "language": "Idioma",
    "timezone": "Zona horaria",
    "incompleteFields": "Campos incompletos",
    "createdAt": "Creado el",
    "updatedAt": "Actualizado el",
    "completedAt": "Completado el",
    "headOfInternationalOrganization": "Jefe de organización internacional",
    "maritalStatus": "Estado civil",
    "spouseTitle": "Título del cónyuge",
    "numberOfDependents": "Número de dependientes",
    "spouseFirstName": "Nombre del cónyuge",
    "spouseMiddleName": "Segundo nombre del cónyuge",
    "spouseLastName": "Apellido del cónyuge",
    "spouseEmail": "Correo del cónyuge",
    "spouseEmployerName": "Empleador del cónyuge",
    "spouseEmployerCompanyPhone": "Teléfono empresa del cónyuge",
    "spouseEmploymentStatus": "Situación laboral del cónyuge",
    "spouseEmploymentType": "Tipo de empleo del cónyuge",
    "spouseCompanyType": "Tipo de empresa del cónyuge",
    "spouseJobTitle": "Cargo del cónyuge",
    "spouseAnnualIncomeCents": "Ingreso anual del cónyuge (centavos)",
    "spouseAnnualIncomeStr": "Ingreso anual del cónyuge (cadena)",
    "spouseAreaOfStudy": "Área de estudio del cónyuge",
    "spouseDateOfBirth": "Fecha de nacimiento del cónyuge",
    "spouseTaxId": "NIF del cónyuge",
    "spouseTaxIdDisclosed": "NIF del cónyuge divulgado",
    "spouseTaxIdType": "Tipo de NIF del cónyuge",
    "lastUpdatedBy": "Última actualización por",
    "iDCheckCompleted": "Verificación de identidad completada",
    "iDCheckRetrigger": "Reactivar verificación de identidad",
    "insiderSymbols": "Símbolos de información privilegiada",
    "ssSymbols": "Símbolos SS",
    "complianceIssueSource": "Origen del problema de cumplimiento",
    "complianceState": "Estado de cumplimiento",
    "affiliateOnly": "Solo afiliado",
    "lastSuitabilityReviewAt": "Última revisión de idoneidad el",
    "iDVerified": "Identidad verificada",
    "hasCheckedPolicyAndCondition": "Ha aceptado políticas y condiciones",
    "bulkAccountOpening": "Apertura masiva de cuentas",
    "suitabilityReviewOverdue": "Revisión de idoneidad vencida",
    "sinExists": "NIF existente",
    "inProvinceSince": "En la provincia desde",
    "countryOfTaxResidence": "País de residencia fiscal",
    "employerName": "Nombre del empleador",
    "employerCompanyPhone": "Teléfono de la empresa",
    "employmentSituation": "Situación laboral",
    "employmentSituationOtherDescription": "Otra descripción de la situación",
    "sourceOfWealth": "Origen del patrimonio",
    "sourceOfWealthOtherDescription": "Otra descripción del origen",
    "sourceOfFunds": "Origen de los fondos",
    "sourceOfFundsOtherDescription": "Otra descripción de los fondos",
    "uniqueCircumstances": "Circunstancias particulares",
    "preferredMethodOfCommunication": "Método de comunicación preferido",
    "preferredMethodOfCommunicationOtherDescription": "Otro método de comunicación",
    "readyToSignAgreement": "Listo para firmar acuerdo",
    "type": "Tipo",
    "entityName": "Nombre de la entidad",
    "typeOfTrust": "Tipo de fideicomiso",
    "identificationType": "Tipo de identificación",
    "registrationNumber": "Número de registro",
    "charityRegistrationNumber": "Número de organización benéfica",
    "establishedDate": "Fecha de constitución",
    "countryOfRegistration": "País de registro",
    "businessPhone": "Teléfono comercial",
    "yearEnd": "Cierre de ejercicio",
    "regulatorName": "Nombre del regulador",
    "firmNumber": "Número de la firma",
    "issuerName": "Nombre del emisor",
    "issuerTicker": "Símbolo del emisor",
    "issuerExchange": "Bolsa del emisor",
    "parentCompanyName": "Nombre de la matriz",
    "isEntityRegulated": "Entidad regulada",
    "isReportingIssuer": "Emisor declarante",
    "isRegisteredWithCRA": "Registrado en CRA",
    "receivesDonationsFromPublic": "Recibe donaciones del público",
    "isAFinancialEntity": "Entidad financiera",
    "isAffiliateOfFinancialEntity": "Afiliada de entidad financiera",
    "instructionsFromFinancialEntity": "Instrucciones de entidad financiera",
    "isPublicBody": "Organismo público",
    "isLargeCorporation": "Gran corporación",
    "hasGuarantor": "Tiene garante",
    "tradingAuthorityOverAccountGranted": "Autoridad de operaciones concedida",
    "discretionOverAccountGranted": "Discreción sobre la cuenta concedida",
    "advisorInterest": "Interés del asesor",
    "advisorInterestDetail": "Detalle del interés del asesor",
    "investmentFirmTrade": "Operación de la firma de inversión",
    "useBorrowedMoney": "Uso de dinero prestado",
    "taxNumber": "Número fiscal",
    "isForThirdParty": "Para terceros",
    "tradingAuthorityName": "Nombre de la autoridad de operaciones",
    "investmentFirmTradeName": "Nombre de la operación de la firma",
    "otherPersonGuaranteeNames": "Nombres de otros garantes",
    "thirdPartyName": "Nombre del tercero",
    "isNonProfit": "Sin fines de lucro",
    "positionAtEntity": "Cargo en la entidad",
    "isVulnerablePerson": "Persona vulnerable",
    "isOwnerOfEntity": "Propietario de la entidad",
    "fatcaStatus": "Estado FATCA",
    "fatcaStatusOtherDescription": "Otra descripción del estado FATCA",
    "taxId": "NIF",
    "taxIdDisclosed": "NIF divulgado",
    "taxIdType": "Tipo de NIF",
    "nextSuitabilityReviewAt": "Próxima revisión de idoneidad el",
    "riskScore": "Puntuación de riesgo",
    "netWorthCents": "Patrimonio neto (centavos)",
    "totalAssetsCents": "Activos totales (centavos)",
    "discretionOverAccountGrantedReason": "Motivo de la discreción concedida",
    "convertedFromAffiliateInvitation": "Convertido desde invitación de afiliado",
    "physicalAddress": "Dirección física",
    "organization": "Organización",
    "fraudRisk": "Riesgo de fraude",
    "feeTier": "Nivel de comisión",
    "applicableFeeTier": "Nivel de comisión aplicable",
    "billingSchedule": "Calendario de facturación",
    "applicableBillingSchedule": "Calendario de facturación aplicable",
    "latestIdVerification": "Última verificación de identidad",
    "trustedContactPerson": "Persona de contacto de confianza",
    "suggestedFinancialProduct": "Producto financiero sugerido",
    "statistics": "Estadísticas",
    "alternateAddress": "Dirección física alternativa",
    "mailingAddress": "Dirección postal",
    "employerCompanyAddress": "Dirección del empleador",
    "spouseAddress": "Dirección del cónyuge",
    "spouseEmployerCompanyAddress": "Dirección del empleador del cónyuge"
  },
  "accountGroup": {
    "id": "ID",
    "translatedName": "Nombre traducido",
    "type": "Tipo",
    "state": "Estado",
    "totalAccounts": "Total de cuentas",
    "lastUpdatedBy": "Última actualización por",
    "createdAt": "Creado el",
    "user": "Usuario",
    "householdClientGroup": "ClientGroup",
    "organization": "Organización",
    "statistics": "Estadísticas"
  },
  "clientGroup": {
    "stringId": "ID de cadena",
    "type": "Tipo",
    "availableCurrencies": "Monedas disponibles",
    "id": "ID",
    "name": "Nombre",
    "state": "Estado",
    "completedAt": "Completado el",
    "incompleteFields": "Campos incompletos",
    "primaryEmail": "Correo principal",
    "phone": "Teléfono",
    "businessIsMemberOfIiroc": "Empresa miembro de IIROC",
    "establishedDate": "Fecha de constitución",
    "corporationCountry": "País de la corporación",
    "incorporationNumber": "Número de incorporación",
    "businessType": "Tipo de negocio",
    "taxNumber": "Número fiscal",
    "accountNumber": "Número de cuenta",
    "taxNumberDisclosed": "Número fiscal divulgado",
    "createdAt": "Creado el",
    "primaryUser": "Usuario principal",
    "organization": "Organización",
    "feeTier": "Nivel de comisión",
    "applicableFeeTier": "Nivel de comisión aplicable",
    "billingSchedule": "Calendario de facturación",
    "applicableBillingSchedule": "Calendario de facturación aplicable",
    "physicalAddress": "Dirección física",
    "statistics": "Estadísticas"
  },
  "organization": {
    "id": "ID",
    "embeddedExperienceLogoUrl": "URL del logotipo de experiencia integrada",
    "defaultBillingSchedule": "Calendario de facturación predeterminado",
    "defaultFeeTier": "Nivel de comisión predeterminado",
    "translatedName": "Nombre traducido",
    "subdomain": "Subdominio",
    "parent": "Padre",
    "minInvestAmountCents": "Monto mínimo de inversión (centavos)",
    "minInitialDepositCents": "Depósito inicial mínimo (centavos)",
    "translatedTermsAndConditionsUrl": "URL de términos y condiciones traducidos",
    "translatedSupportUrl": "URL de soporte traducida",
    "translatedHelpCentreUrl": "URL del centro de ayuda traducida",
    "cashOnHoldToTradeDays": "Días de efectivo retenido para operar",
    "cashOnHoldToWithdrawDays": "Días de efectivo retenido para retiro",
    "cancelTransferCutoffDays": "Días límite para cancelar transferencia",
    "defaultTradingProcess": "Proceso de operaciones predeterminado",
    "bulkTradingProcess": "Proceso de operaciones masivas",
    "minDepositCents": "Depósito mínimo (centavos)",
    "productShelfCurrencies": "Monedas de productos",
    "customUrl": "URL personalizada",
    "faviconLink": "Enlace del favicon",
    "browserTabTitle": "Título de la pestaña",
    "localization": "Localización",
    "applicableLocalization": "Localización aplicable",
    "profileReviewTimeInMonths": "Plazo de revisión de perfil (meses)",
    "repCode": "Código del representante",
    "entityName": "Nombre de la entidad",
    "minRecurringDepositCents": "Depósito recurrente mínimo (centavos)",
    "defaultAuthenticationConnection": "Conexión de autenticación predeterminada",
    "multiFactorAuthenticationOptions": "Opciones de autenticación multifactor",
    "baseCurrency": "Moneda base",
    "jurisdictions": "Jurisdicciones habilitadas",
    "applicableJurisdictions": "Jurisdicciones aplicables"
  },
  "custodianConnection": {
    "id": "ID",
    "name": "Nombre",
    "moneyAccount": "Cuenta de efectivo",
    "inventoryAccount": "Cuenta de inventario",
    "type": "Tipo",
    "repCode": "Código del representante",
    "notificationEmails": "Correos de notificación",
    "default": "Predeterminado",
    "enableCustodianActivityImport": "Habilitar importación de actividad del custodio",
    "allowTransactionCreation": "Permitir creación de transacciones",
    "enableCustodianSnapshotImport": "Habilitar importación de instantáneas del custodio",
    "enableFetchCustodianStatistics": "Habilitar obtención de estadísticas del custodio",
    "enableFetchCustodianUpcomingTransactions": "Habilitar obtención de transacciones próximas",
    "enableFetchCustodianSuitability": "Habilitar obtención de idoneidad del custodio",
    "enableFetchCustodianSnapshotHistory": "Habilitar historial de instantáneas del custodio",
    "enableFetchCustodianTransactions": "Habilitar obtención de transacciones del custodio",
    "enableFetchCustodianProjectedIncome": "Habilitar obtención de ingresos proyectados",
    "enableFetchCustodianCustomFields": "Habilitar obtención de campos personalizados",
    "enableCustodianOrganizationImport": "Habilitar importación de organización del custodio",
    "enableCustodianOrganizationUserImport": "Habilitar importación de usuarios de organización",
    "enableAutoReconcileActivities": "Habilitar reconciliación automática de actividades",
    "enableAutoReconcilePositions": "Habilitar reconciliación automática de posiciones",
    "custodianActivityImportFilePaths": "Rutas de importación de actividades",
    "custodianSnapshotImportFilePaths": "Rutas de importación de instantáneas",
    "custodianUsersImportFilePath": "Ruta de importación de usuarios del custodio",
    "customerName": "Nombre del cliente",
    "enablleTransferSubmission": "Habilitar envío de transferencias",
    "enableCustodianUserImport": "Habilitar importación de usuarios del custodio",
    "enableCustodianAccountImport": "Habilitar importación de cuentas del custodio",
    "transferSubmissionType": "Tipo de envío de transferencia",
    "accountOpeningSubmissionType": "Tipo de envío de apertura de cuenta",
    "enableAccountOpeningSubmission": "Habilitar envío de apertura de cuenta",
    "disabledFlagTypes": "Tipos de indicadores deshabilitados",
    "reconciliationType": "Tipo de reconciliación",
    "accountTypeSettings": "Configuración del tipo de cuenta",
    "baseCurrency": "Moneda base",
    "allowFractionalTrading": "Permitir operaciones fraccionarias",
    "fetchLivePrices": "Obtener precios en vivo",
    "enableFetchCustodianStatements": "Habilitar obtención de estados del custodio",
    "enableCreateCustodianDepositTransfers": "Habilitar creación de transferencias de depósito",
    "enableCancelCustodianDepositTransfer": "Habilitar cancelación de transferencia de depósito",
    "enableFetchCustodianNotifications": "Habilitar obtención de notificaciones del custodio",
    "enableChallengedCustodianDepositTransfer": "Habilitar transferencia de depósito impugnada",
    "enableCustodianCredentialsManager": "Habilitar gestor de credenciales del custodio",
    "enableSaveInternalRecordsOfCustodianDepositTransfers": "Habilitar registro interno de transferencias",
    "allowCashAsDepositTarget": "Permitir efectivo como destino de depósito",
    "bulkTradeAllowedExchanges": "Bolsas permitidas para operaciones masivas",
    "disableCorpInventoryAccount": "Deshabilitar cuenta de inventario corporativo"
  },
  "enabledJurisdictions": {
    "all": "Todas",
    "only": "Solo"
  },
  "repCode": {
    "code": "Código",
    "id": "ID",
    "name": "Nombre",
    "archived": "Archivado",
    "state": "Estado"
  },
  "transactionTotal": {
    "totalCount": "Conteo total",
    "totalCents": "Total (centavos)"
  },
  "fraudRisk": {
    "id": "ID",
    "score": "Puntuación",
    "lastUpdatedBy": "Última actualización por",
    "notes": "Notas"
  },
  "alternatePhysicalAddress": {
    "line1": "Línea 1",
    "line2": "Línea 2",
    "city": "Ciudad",
    "jurisdiction": "Jurisdicción",
    "country": "País",
    "postal": "Código postal"
  },
  "alternateAddress": {
    "city": "Ciudad",
    "country": "País",
    "jurisdiction": "Jurisdicción",
    "postal": "Código postal",
    "line1": "Línea 1",
    "line2": "Línea 2"
  },
  "trustedContactPerson": {
    "name": "Nombre",
    "relation": "Relación",
    "email": "Correo",
    "phone": "Teléfono",
    "physicalAddress": "Dirección física"
  },
  "idVerification": {
    "id": "ID",
    "methodOfIDVerification": "Método de verificación de identidad",
    "verifiedDate": "Fecha de verificación",
    "userName": "Nombre de usuario",
    "documentType": "Tipo de documento",
    "documentID": "ID del documento",
    "documentIssuingJurisdication": "Jurisdicción emisora del documento",
    "documentExpiryDate": "Fecha de vencimiento del documento",
    "secondaryDocumentType": "Tipo de documento secundario",
    "secondaryDocumentUserName": "Nombre en documento secundario",
    "secondaryDocumentID": "ID del documento secundario",
    "secondaryDocumentIssuingJurisdication": "Jurisdicción emisora del documento secundario",
    "secondaryDocumentExpiryDate": "Fecha de vencimiento del documento secundario",
    "secondaryDocumentDateOfBirth": "Fecha de nacimiento en documento secundario",
    "secondaryDocumentVerifiedDate": "Fecha de verificación del documento secundario",
    "state": "Estado",
    "creditFileSource": "Origen del archivo de crédito",
    "address": "Dirección"
  },
  "physicalAddress": {
    "unitNumber": "Número de unidad",
    "houseNumber": "Número",
    "streetName": "Nombre de calle",
    "neighborhood": "Barrio",
    "city": "Ciudad",
    "jurisdiction": "Jurisdicción",
    "country": "País",
    "postal": "Código postal"
  },
  "feeTier": {
    "id": "ID",
    "name": "Nombre",
    "default": "Predeterminado",
    "blendedGrid": "Cuadrícula combinada",
    "gridScopeType": "Tipo de alcance de la cuadrícula",
    "flatAnnualFeeBps": "Comisión anual fija (bps)",
    "discountPercentage": "Porcentaje de descuento",
    "chargeForCashOnHold": "Cargo por efectivo retenido",
    "chargeForCash": "Cargo por efectivo",
    "state": "Estado",
    "requestId": "ID de solicitud",
    "type": "Tipo",
    "createdAt": "Creado el",
    "updatedAt": "Actualizado el",
    "extensionKey": "Clave de extensión",
    "resourceKey": "Clave de recurso",
    "extensionVersion": "Versión de extensión"
  },
  "billingSchedule": {
    "id": "ID",
    "default": "Predeterminado",
    "frequency": "Frecuencia",
    "nextBillingDate": "Próxima fecha de facturación",
    "nextCalculationDate": "Próxima fecha de cálculo",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de fin",
    "state": "Estado",
    "requestId": "ID de solicitud",
    "createdAt": "Creado el",
    "updatedAt": "Actualizado el",
    "extensionKey": "Clave de extensión",
    "resourceKey": "Clave de recurso",
    "extensionVersion": "Versión de extensión"
  },
  "financialProduct": {
    "id": "ID",
    "stringId": "ID de cadena",
    "priceHistoryUrl": "URL del historial de precios",
    "name": "Nombre",
    "translatedName": "Nombre traducido",
    "state": "Estado",
    "suggestedMinScore": "Puntuación mínima sugerida",
    "suggestedMaxScore": "Puntuación máxima sugerida",
    "lowThresholdScore": "Puntuación de umbral bajo",
    "tradeable": "Negociable",
    "suggestable": "Sugerible",
    "autoUpdatePrices": "Actualización automática de precios",
    "assignable": "Asignable",
    "ticker": "Símbolo",
    "exchange": "Bolsa",
    "currency": "Moneda",
    "originalCurrency": "Moneda original",
    "forecastedRateOfReturn": "Tasa de rendimiento prevista",
    "forecastedStandardDeviation": "Desviación estándar prevista",
    "currentPriceCents": "Precio actual (centavos)",
    "originalCurrentPriceCents": "Precio actual original (centavos)",
    "portfolioDescription": "Descripción del portafolio",
    "translatedPortfolioDescription": "Descripción del portafolio traducida",
    "portfolioDisclaimer": "Aviso del portafolio",
    "translatedPortfolioDisclaimer": "Aviso del portafolio traducido",
    "investmentObjective": "Objetivo de inversión",
    "translatedInvestmentObjective": "Objetivo de inversión traducido",
    "translatedLiquidity": "Liquidez traducida",
    "updatedAt": "Actualizado el",
    "riskReturnLevel": "Nivel riesgo-retorno",
    "isCash": "Efectivo",
    "substituteFinancialProduct": "Producto financiero sustituto",
    "isPartial": "Parcial",
    "waivedFeePercentage": "Porcentaje de comisión exenta",
    "taxRank": "Rango fiscal",
    "settlementDays": "Días de liquidación",
    "volatile": "Volátil",
    "translatedUrl": "URL traducida",
    "cusip": "CUSIP",
    "isin": "ISIN",
    "ric": "RIC",
    "exchangeMic": "MIC de la bolsa",
    "foreignExchangeRate": "Tipo de cambio",
    "riskProfileName": "Nombre del perfil de riesgo",
    "riskProfileDescription": "Descripción del perfil de riesgo",
    "translatedThemeName": "Nombre del tema traducido",
    "strategy": "Estrategia",
    "type": "Tipo",
    "zeroPercentCash": "Cero por ciento efectivo",
    "multiplier": "Multiplicador",
    "cloneOf": "Clon de",
    "fundSeries": "Serie del fondo",
    "theme": "Tema",
    "primaryAssetClass": "Clase de activos principal",
    "secondaryAssetClass": "Clase de activos secundaria",
    "tertiaryAssetClass": "Clase de activos terciaria",
    "schedule": "Calendario",
    "portfolioTemplate": "Plantilla de portafolio"
  },
  "theme": {
    "id": "ID",
    "name": "Nombre",
    "translatedName": "Nombre traducido",
    "description": "Descripción",
    "translatedDescription": "Descripción traducida",
    "translatedShortDescription": "Descripción corta traducida",
    "key": "Clave",
    "core": "Principal",
    "iconKey": "Clave de icono",
    "state": "Estado"
  },
  "assetClass": {
    "id": "ID",
    "stringId": "ID de cadena",
    "key": "Clave",
    "name": "Nombre",
    "description": "Descripción",
    "translatedName": "Nombre traducido",
    "translatedDescription": "Descripción traducida",
    "state": "Estado",
    "includeCash": "Incluir efectivo",
    "riskLevel": "Nivel de riesgo"
  },
  "schedule": {
    "id": "ID",
    "name": "Nombre",
    "dates": "Fechas",
    "nextDate": "Próxima fecha",
    "associatedFinancialProductsCount": "Cantidad de productos financieros asociados"
  },
  "portfolioTemplate": {
    "id": "ID",
    "name": "Nombre",
    "translatedName": "Nombre traducido",
    "translatedTemplateDescription": "Descripción del modelo traducida",
    "state": "Estado",
    "createdAt": "Creado el",
    "updatedAt": "Actualizado el"
  },
  "statistics": {
    "stringId": "ID de cadena",
    "currency": "Moneda",
    "objectType": "Tipo de objeto",
    "forUserId": "Para ID de usuario",
    "marketValueCents": "Valor de mercado (centavos)",
    "netContributionCents": "Contribución neta (centavos)",
    "newContributionCents": "Nueva contribución (centavos)",
    "simpleReturnAmount": "Monto del rendimiento simple",
    "simpleReturnPercent": "Porcentaje del rendimiento simple",
    "timeWeightedReturn": "Rendimiento ponderado por tiempo",
    "moneyWeightedReturn": "Rendimiento ponderado por flujos",
    "netContributionCentsInFiscalYear": "Contribución neta en el ejercicio (centavos)",
    "id": "ID",
    "capitalGainsAndLossesInFiscalYear": "Ganancias y pérdidas de capital en el ejercicio",
    "depositContributionCents": "Contribución de depósitos (centavos)",
    "withdrawContributionCents": "Contribución de retiros (centavos)",
    "lastUpdatedAt": "Última actualización el",
    "eodMarketValueCents": "Valor de mercado al cierre (centavos)",
    "moneyAvailableCents": "Efectivo disponible (centavos)",
    "expectedMoneyAvailableCents": "Efectivo esperado (centavos)",
    "pendingContributionCents": "Contribución pendiente (centavos)",
    "pendingCashCents": "Efectivo pendiente (centavos)",
    "pendingWithdrawCents": "Retiro pendiente (centavos)",
    "availableFundsToWithdrawCents": "Fondos disponibles para retiro (centavos)",
    "cashOnHoldToTradeCents": "Efectivo retenido para operar (centavos)",
    "cashOnHoldToWithdrawCents": "Efectivo retenido para retiro (centavos)",
    "totalBookCostCents": "Costo contable total (centavos)",
    "totalPercentage": "Porcentaje total",
    "taxLossHarvestCreditInFiscalYear": "Crédito por pérdida fiscal en el ejercicio",
    "unrealizedGainsAndLoss": "Ganancias y pérdidas no realizadas"
  },
  "taxLossHarvestCredit": {
    "id": "ID",
    "account": "Cuenta",
    "year": "Año",
    "creditsCents": "Créditos (centavos)"
  },
  "unrealizedGainsAndLoss": {
    "unrealizedGainsAndLossCents": "Ganancias y pérdidas no realizadas (centavos)",
    "unrealizedGainsAndLossCentsPercentage": "Porcentaje de ganancias y pérdidas no realizadas"
  },
  "custodian": {
    "id": "ID",
    "name": "Nombre",
    "moneyAccount": "Cuenta de efectivo",
    "inventoryAccount": "Cuenta de inventario",
    "type": "Tipo",
    "repCode": "Código del representante",
    "notificationEmails": "Correos de notificación",
    "customerName": "Nombre del cliente"
  },
  "scheduledIncomeFundTransfer": {
    "id": "ID",
    "frequency": "Frecuencia",
    "scheduledDate": "Fecha programada",
    "annualAmountCents": "Monto anual (centavos)",
    "amountPayableType": "Tipo de monto pagadero",
    "dateOfBirth": "Fecha de nacimiento",
    "minimumAnnualAmountCents": "Monto anual mínimo (centavos)",
    "state": "Estado",
    "taxOption": "Opción fiscal",
    "specialTaxRate": "Tasa impositiva especial",
    "currency": "Moneda",
    "subAccount": "Subcuenta",
    "bankAccount": "Cuenta bancaria"
  },
  "bankAccount": {
    "id": "ID",
    "stringId": "ID de cadena",
    "name": "Nombre",
    "institutionNumber": "Número de institución",
    "routingNumber": "Número de ruteo",
    "transitNumber": "Número de tránsito",
    "processorToken": "Token del procesador",
    "bankAccountType": "Tipo",
    "bankAccountNumber": "Número",
    "transitNumberDisclosed": "Número de tránsito divulgado",
    "bankAccountNumberDisclosed": "Número divulgado",
    "state": "Estado",
    "createdAt": "Creado el",
    "updatedAt": "Actualizado el",
    "source": "Origen",
    "EftEligibleRatio": "Ratio de elegibilidad para transferencia",
    "failReason": "Motivo del fallo",
    "fieldMatchRate": "Tasa de coincidencia de campos",
    "bankAccountHolderName": "Nombre del titular",
    "currency": "Moneda",
    "downloadUrls": "URLs de descarga",
    "user": "Usuario",
    "bankAccountTransitPhysicalAddress": "Dirección física de tránsito de cuenta bancaria"
  },
  "bankAccountTransitPhysicalAddress": {
    "houseNumber": "Número",
    "unitNumber": "Número de unidad",
    "streetName": "Nombre de calle",
    "city": "Ciudad",
    "jurisdiction": "Jurisdicción",
    "country": "País",
    "postal": "Código postal"
  }
}
